import { useEffect, useState } from "react";
import store from "../../../_services/store";
import parse from 'html-react-parser';
import { ALPHABET, COLORS } from "../../../constants";
import labels from '../../../_translations/symptom.json';
import { ReactComponent as SearchLogo } from "../../../assets/svg/search.svg";
import { ModalButton, ModalContent, ModalTitle, SymptomsSection } from "./components";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { observer } from "mobx-react";
import {
  Header,
  PageTitle,
  SearchInputContainer,
  SearchInput,
  Main,
  StyledModal,
  Image
} from "../../_ui";


const SymptomsPage = observer(() => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectedSymptomId, setSelectedSymptomId] = useState<number | null>();
  const navigate = useNavigate();

  useEffect(() => {
    if (store.symptomesList.length === 0) {
      store.getSymptomes();
    }
  }, []);

  useEffect(() => {
    if(typeof selectedSymptomId === 'number'){
      store.getSymptomesDetailsForId(selectedSymptomId);
    }
  }, [selectedSymptomId]);

  const prepareSymptoms = (symptomsList: TSymptome[]) => {
    // create an array of object with alphabet letter key and an array of molecules starting with this letter 
    const symptomsByLetters = ALPHABET.map(key => {
      const symptomsStartWithKey = symptomsList?.filter((mol: TMolecule) => mol.title.toUpperCase().startsWith(key) &&
        mol.title.toLowerCase().includes(searchValue));

      if (symptomsStartWithKey.length > 0) {
        return {
          [key]: symptomsStartWithKey
        }
      }
    }).filter(e => e);// clean up undefined

    return symptomsByLetters
  }

  const searchForCriteria = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const selectedSymptom = store.symptomesList?.find(elm => +elm.id === selectedSymptomId)

  const symptoms = prepareSymptoms(store.symptomesList || []);

  return (
    <div className="fadeIn">
      <Header bgUrl={"/images/bg-symptoms.jpeg"}>
        <PageTitle>{labels[store.currentLanguage].title}</PageTitle>
        <SearchInputContainer>
          <SearchLogo  />
          <SearchInput
            type="text"
            placeholder={labels[store.currentLanguage].search}
            onChange={searchForCriteria}
          />
        </SearchInputContainer>
      </Header>
      <Main>
        <div style={{paddingBottom: '120px'}}>
          {symptoms?.map(e => <SymptomsSection setSelectedSymptomDetail={setSelectedSymptomId} key={`Section_${Object.keys(e!)[0]}`} symptomsSection={e} />)}
          </div>
      </Main>

      {/* @ts-ignore */}
      {selectedSymptomId && <StyledModal
        withPadding={false}
        isOpen={!!selectedSymptomId}
        onRequestClose={() => setSelectedSymptomId(null)}
        overlay={true}
        withWrapper={true}
      >
        <div style={{ padding: 0 }}>
          <Image width='100%' height='auto' src={selectedSymptom?.image[0]} style={{ borderRadius: '32px 32px 0px 0px' }} />
          <ModalTitle>{selectedSymptom?.title}</ModalTitle>
          <ModalContent>{parse(store.symptomeDetail?.sections?.[0].content || "error")}</ModalContent>
          <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", padding: "0px 40px" }}>
            <ModalButton
              color={COLORS.SECONDARY}
              onClick={() => setSelectedSymptomId(null)}
            >
              {labels[store.currentLanguage].buttons.back}
            </ModalButton>
            <ModalButton
              color={COLORS.PRIMARY}
              onClick={() => navigate(ROUTES.SYMPTOM_DETAIL(selectedSymptom?.id!))}
            >
              {labels[store.currentLanguage].buttons.viewmore}
            </ModalButton>
          </div>
        </div>
      </StyledModal>}
    </div>
  )
});

export default SymptomsPage;